import { GLOBAL_LOADER_STEP } from '@client/enums';

import { accessingIntegrationEditor, editActionsMenu } from './accessing-integration-editor';
import { editingIntegration } from './editing-integration';
import { savingIntegration } from './save';
import { updatingIntegration } from './updating-integration';
import {
  diagnosticsHtmlSource,
  diagnosticsRenderedHtml,
  diagnosticsRenderedText,
  diagnosticsShowMore,
  diagnosticsTool
} from './viewing-diagnostics';

let editSteps = [
  editingIntegration,
  accessingIntegrationEditor,
  editActionsMenu,
  GLOBAL_LOADER_STEP,
  updatingIntegration,
  diagnosticsShowMore,
  diagnosticsHtmlSource,
  diagnosticsRenderedHtml,
  diagnosticsRenderedText,
  diagnosticsTool,
  savingIntegration
];

editSteps[3] = {
  ...editSteps[3],
  popover: {
    ...editSteps[3].popover,
    title: 'Loading integration...'
  }
};

export const EDIT_STEPS = editSteps;
